import React, { Component } from "react";
import "./App.css";
import Login from "./component/Login/Login";
import Chat from "./component/Chat/Chat";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import LoginRequest from "./request/LoginRequest";
import SingletonBootConfig from "./request/SingletonBootConfig";
import Surveys from "./component/Surveys/Surveys";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import ColorHelper from "./helper/ColorHelper";
import MoreOptions from "./component/Chat/MoreOptions";
import NotAvailable from "./component/NotAvailable/NotAvailable";

export default class App extends Component {
  state = {
    dropdownOpen: false,
    userName: null,
    session: "",
    agentId: 0,
    agentName: "NO_AGENT",
    message: "",
    showSurvey: false,
    mainBtn: null,
    moreOptions: false,
    msgList: [],
    chatId: 0,
    maxImgToSend: 0,
  };

  componentDidMount() {
    SingletonBootConfig.getInstance();
    let colorHelper = ColorHelper.getInstance();
    window.onbeforeunload = function () {
      try {
        LoginRequest.AbandonedSync(this.state.session);
      } catch (error) {
        LoginRequest.Abandoned(this.state.session);
      }
    }.bind(this);
    this.setState({
      mainBtn: colorHelper.getMainChatBtnStyle(),
    });
  }

  isIE = () => {
    var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    var msie = ua.indexOf("MSIE "); // IE 10 or older
    var trident = ua.indexOf("Trident/"); //IE 11

    return msie > 0 || trident > 0;
  };

  logout = async (isRestoreState = true) => {
    try {
      await LoginRequest.AbandonedSync(this.state.session);
    } catch (error) {
      console.warn(error);
      await LoginRequest.Abandoned(this.state.session);
    }
    if (isRestoreState) {
      this.onRestoreStates();
    }
  };

  setAgentData = (agentId, agentName, message) => {
    this.setState({ agentId, agentName, message });
  };

  ontoggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });
  onNameFilled = (userName) => this.setState({ userName });
  onSessionStart = (
    session,
    agentId,
    agentName,
    message,
    timeOut,
    chatId,
    maxImgToSend
  ) => {
    this.setState({
      session,
      agentId,
      agentName,
      message,
      timeOut,
      chatId,
      maxImgToSend,
    });
  };
  minimize = () => {
    this.setState({ dropdownOpen: false });
  };

  closeConversation = () => {
    this.logout(false);
    this.showSurvey();
  };

  showSurvey = () => this.setState({ showSurvey: true });

  onMoreOptionsChange = () => this.setState({ showMore: !this.state.showMore });

  onMsgList = (list) => {
    this.setState({ msgList: list });
  };

  onRestoreStates = () => {
    this.setState({
      dropdownOpen: true,
      userName: null,
      session: "",
      agentId: 0,
      agentName: "NO_AGENT",
      message: "",
      showSurvey: false,
      showMore: false,
    });
  };

  embedded = () => {
    const {
      agentName,
      session,
      showSurvey,
      agentId,
      showMore,
      moreOptions,
      msgList,
      userName,
      message,
      chatId,
      maxImgToSend,
    } = this.state;
    if (showMore) {
      return (
        <MoreOptions
          onMoreOptionsChange={this.onMoreOptionsChange}
          agentName={agentName}
          userName={userName}
          msgList={msgList}
          session={session}
          minimize={this.minimize}
        />
      );
    } else {
      if (agentId !== 0) {
        if (showSurvey) {
          return (
            <Surveys
              agentId={agentId}
              onRestoreStates={this.onRestoreStates}
              minimize={this.minimize}
            />
          );
        } else {
          return (
            <Chat
              welcomemessage={message}
              agentId={agentId}
              agentName={agentName}
              session={session}
              minimize={this.minimize}
              closeConversation={this.closeConversation}
              showSurvey={this.showSurvey}
              setAgentData={this.setAgentData}
              logout={this.logout}
              onMoreOptionsChange={this.onMoreOptionsChange}
              moreOptions={moreOptions}
              msgList={msgList}
              onMsgList={this.onMsgList}
              timeOut={this.state.timeOut}
              chatId={chatId}
              maxImgToSend={maxImgToSend}
            />
          );
        }
      } else {
        if (this.isIE()) {
          return (
            <NotAvailable
              dropdownOpen={this.state.dropdownOpen}
              minimize={this.minimize}
            />
          );
        } else {
          return (
            <Login
              onNameFilled={this.onNameFilled}
              onSessionStart={this.onSessionStart}
              minimize={this.minimize}
            />
          );
        }
      }
    }
  };

  render() {
    const { agentName } = this.state;
    const { chipChat: chatLabels } = window["labels"];
    const {
      embedded,
      btnChat,
      chatSize,
      resize: { active = false, resizeHeight = null, resizeWidth = null } = {},
    } = window["boot"];

    return (
      <div
        className={`container ${!active && chatSize}`}
        style={{
          ...(active && {
            height: resizeHeight,
            width: resizeWidth,
          }),
          ...(embedded && {
            paddingRight: 0,
            marginBottom: "0rem",
          }),
        }}
      >
        {!embedded && !this.state.dropdownOpen ? (
          <div>
            <button
              className={`btn-chat ${btnChat}`}
              isOpen={this.state.dropdownOpen}
              onClick={this.ontoggle}
            >
              <i className="gcl-icon chat-web" />
              {agentName !== "NO_AGENT"
                ? chatLabels.chipChatWithAgent + agentName.split(" ")[0]
                : chatLabels.chipChat}
            </button>
          </div>
        ) : (
          <div className="chat-container-in-page">{this.embedded()}</div>
        )}
      </div>
    );
  }
}
